import styled from 'styled-components';

export const FooterContent = styled.div`
  width: 100%;
  padding: 15px;
  background: #00933b;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #000000;
  text-align: center;
  gap: 14px;
  flex-wrap: wrap;

  a,
  button {
    border: 0;
    background: transparent;
    color: #001d0c;
    cursor: pointer;
    font-weight: 700;
    text-decoration: underline;
  }

  div {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
  }

  @media screen and (max-width: 960px) {
    font-size: 13px;
    padding: 10px 50px;
    justify-content: center;
  }
`;
